import { getRouteTargetPage } from '@inwink/react-utils/navigation/getroutetargetpage.community';
import { previewHost } from '@@data/preview';
import { ICommunityDetail } from '@@community/data/communitydata';
import { getCommunityPreviewId } from '@@community/api/communitydetail';

export function getCommunityPreviewTinyUrl(detail: ICommunityDetail): Promise<string> {
    const tinyUrl = (detail as any).communityKey || (detail as any).tinyUrl;
    return getCommunityPreviewId(detail.id).then((res) => {
        return tinyUrl + "_" + res.previewId;
    });
}

export function getCommunityPreviewUrl(detail: ICommunityDetail): Promise<string> {
    return getCommunityPreviewTinyUrl(detail).then((res) => {
        return Promise.resolve(previewHost(detail.previewHost) + res);
    });
}

export function openCommunityPreview(
    communitydetail: ICommunityDetail,
    _url = "",
    name = "inwinkpreview",
    pageAlias?,
    _pageType?,
    groupId?: string
) {
    let pageType = _pageType;
    let url = _url;
    if (pageType === "contentpage") {
        pageType = "content";
    }
    const targetPage = getRouteTargetPage(pageAlias, null, null, true);
    if (pageAlias && pageType) {
        // remove 'page' when redirecting on root page
        if (targetPage.length === 0) { pageType = null; }
        url = (pageType ? pageType + '/' : "") + targetPage;
    }

    return getCommunityPreviewUrl(communitydetail).then((previewUrl) => {
        if (groupId) {
            window.open(previewUrl + "/" + url + 'g/' + groupId, name, "");
        } else {
            window.open(previewUrl + "/" + url, name, "");
        }
    });
}

export function openCommunityCMS(
    communitydetail: ICommunityDetail,
    _url?,
    _name?,
    pageAlias?,
    _pageType?,
    openBlankFirst?: boolean
) {
    let pageType = _pageType;
    let url = _url ?? "";
    const name = _name ?? "inwinkcms";
    if (pageType === "contentpage") {
        pageType = "content";
    }

    const targetPage = getRouteTargetPage(pageAlias, null, null, true);
    if (pageAlias && pageType) {
        // remove 'page' when redirecting on root page
        if (targetPage.length === 0 || pageType === "page") { pageType = null; }
        url = (pageType ? pageType + '/' : "") + targetPage;
    }

    let blankWindow;
    if (openBlankFirst) {
        blankWindow = window.open("", name, "");
    }

    return getCommunityPreviewTinyUrl(communitydetail).then((res) => {
        let rooturl = "/preview/";
        if (window.location.host === "localhost:8282") {
            rooturl = "/dev.html#/preview/";
        }
        if (blankWindow) {
            blankWindow.location.href = `${rooturl}${res}/${url}`;
        } else {
            window.open(`${rooturl}${res}/${url}`, name, "");
        }
    });
}